/**
 * @desc mm100 页面获取咨询报价页面入口
 */

import { FunctionComponent } from 'react';
import { GetServerSideProps } from 'next';
import dynamic from 'next/dynamic';
import css from './index.module.scss';
import PageLayout from '@/components/PageLayout';
import SEO from '@/components/utils/SEO';
import { useGlobal } from '@/utils/useGlobal';
import { ActivityIdMap, KeyType } from '@/config/powerkit';

const InfoQuote: any = dynamic(() => import('@/components/PowerKitPreSale/components/PreOrder/InfoQuote'), { ssr: false });

interface QuoteProps {
    isMobile: boolean;
}

const GetQuote: FunctionComponent<QuoteProps> = (props) => {
    const { isMobile } = props;
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');
    const { locale } = useRouter();
    // 多语言 activityId
    const activityId = ActivityIdMap[locale as KeyType] || ActivityIdMap.us;

    return (
        <>
            <PageLayout theme="gray">
                <SEO title={t('preview.seo_title')} description={t('preview.seo_desc')} />
                <section className={`quote-page ${css.getQutoe}`}>
                    <InfoQuote isMobile={isMobile} activityId={activityId}></InfoQuote>
                </section>
            </PageLayout>
        </>
    );
};

export default GetQuote;

export const getServerSideProps: GetServerSideProps = async (context) => {
    // 白名单站点
    const whiteSites: string[] = ['us', 'ca', 'uk', 'eu', 'de', 'fr', 'es', 'it'];
    const flag = whiteSites.includes(context.locale || 'us');
    if (flag) return { props: {} };
    return { notFound: true };
};
